import React from 'react'
import Legal from '../components/Legal/Legal';

export default function Privacy(props) {

    const setTitle = props.setTitle;
    const setProgress = props.setProgress;

    React.useEffect(() => {
        setTitle('Privacy Policy - Travezco');
        setProgress(100);
    }, [setTitle, setProgress])

    return (
        <>
            <Legal name="privacy" />
        </>
    )
}
